import { useEffect } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { PROD_URL } from "assets/constants";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/reducers/authSlice";
import { setEncodedUserProfile } from "../../../utils/authHelpers";
import { token } from "stylis";

const MagicLogin = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let { token } = useParams();
  useEffect(() => {
    localStorage.clear();
    token = token ? token : params.get("token");
    const redirect = params.get("redirect");
    if (!token) return;

    const verifyToken = async () => {
      try {
        const response = await axios.get(`${PROD_URL}auth/magic-login?token=${token}`);
        const res = response.data;
        console.log(response);

        // If verification is complete
        if (res?.data?.verificationComplete) {
          await localStorage.setItem("accessToken", res?.data.token);
          await localStorage.setItem("refreshToken", res?.data.refreshToken);
          await localStorage.setItem("userId", res?.data.userId);
          await localStorage.setItem("isAuthenticated", true);
          await localStorage.setItem("isDistributor", res?.data?.distributionEmailUser);
          await localStorage.setItem("verifiedUserPlan", res?.data.verif2iedUserPlan);
          const encoded = btoa(JSON.stringify(res?.data.isSubscriptionExpired));
          localStorage.setItem("_s43", encoded);
          const verifiedUserPlan = parseInt(localStorage.getItem("verifiedUserPlan") || "0", 10);
          if (verifiedUserPlan === 0) {
            await localStorage.setItem("planStatus", "NoPlan");
          } else if (res?.data.isSubscriptionExpired) {
            await localStorage.setItem("planStatus", "Expired");
          } else {
            await localStorage.setItem("planStatus", "Active");
          }
          setEncodedUserProfile(res?.data);
          dispatch(
            login({
              accessToken: res.data.token,
              userId: res?.data?.userId,
              refreshToken: res?.data?.refreshToken,
              isDistributor: res?.data?.distributionEmailUser,
            })
          );

          toast.success("Logged in successfully!");

          const preSelectedPlan = localStorage.getItem("preSelectedPlan");
          if (redirect) {
            navigate(`/${redirect}`);
          } else if (preSelectedPlan) {
            navigate("/plans", { state: { fromWordPress: true } });
          } else if (verifiedUserPlan === 0) {
            toast.info("Please select a plan to start using Heartline.");
            navigate("/plans");
          } else {
            navigate("/callhistory");
          }
        }
        // If verification is NOT complete
        else {
          const updatedProfile = {
            ...res.data,
            magicToken: token,
          };
          setEncodedUserProfile(updatedProfile);
          toast.warning("Please complete verification.");
          navigate("/verification");
        }
      } catch (err) {
        if (axios.isAxiosError(err)) {
          if (err.response?.status === 401) {
            toast.error("Unauthorized. Magic link expired or invalid.");
          } else {
            toast.error(`Error: ${err?.response?.data?.message || "Unexpected error"}`);
          }
        } else {
          toast.error("Unknown error occurred.");
        }
        navigate("/authentication/sign-in");
      }
    };

    verifyToken();
  }, []);

  return <p>Logging you in...</p>;
};

export default MagicLogin;
